import React, { useState, useEffect } from "react";
import "./CookieBanner.css";
import { useTranslation } from "react-i18next";

// Aviso de cookies con «Aceptar» y «Rechazar» al mismo nivel. Hasta que se
// acepta, Analytics y AdSense funcionan sin cookies y no se cargan los
// afiliados (ver CONSENT_SCRIPT). Se reabre con el evento «tt:cookies».
const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    let stored = null;
    try {
      stored = localStorage.getItem("cookieConsent");
    } catch (e) {}
    if (!stored) setIsVisible(true);
    const open = () => setIsVisible(true);
    window.addEventListener("tt:cookies", open);
    return () => window.removeEventListener("tt:cookies", open);
  }, []);

  const choose = (ok) => {
    if (typeof window.ttSetConsent === "function") window.ttSetConsent(ok);
    else {
      try {
        localStorage.setItem("cookieConsent", ok ? "granted" : "denied");
      } catch (e) {}
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;
  const en = i18n.language?.startsWith("en");

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookies">
      <div className="cookie-banner-content">
        <div className="cookie-banner-label">
          <span role="img" aria-label="cookie" style={{ fontSize: 20 }}>🍪</span> Cookies:
        </div>
        <span>
          {t("cookies")}{" "}
          <a className="cookie-banner-link" href={en ? "/en/privacy-policy" : "/es/politica-de-privacidad"}>
            {t("cookiesMore")}
          </a>
        </span>
      </div>
      <div className="cookie-banner-actions">
        <button className="cookie-banner-button cookie-banner-button--reject" onClick={() => choose(false)}>
          {t("reject")}
        </button>
        <button className="cookie-banner-button" onClick={() => choose(true)}>
          {t("accept")}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner
